module.exports = __webpack_public_path__ + "static/img/premier_league.b2a86b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/bg/premier_league.png
// module id = AWBF
// module chunks = 1